module.exports = __webpack_public_path__ + "img/laroca.424fd465.jpg";